import { defineMessages } from "react-intl";

const PASSWORD_UPDATE_FORM = "password-update-form";

const passwordUpdateFormMessages = defineMessages({
  currentPassword: {
    id: `${PASSWORD_UPDATE_FORM}.current-password`,
    defaultMessage: "Current password",
    description: "Label for current password text input"
  },
  requireCurrentPassword: {
    id: `${PASSWORD_UPDATE_FORM}.require-current-password`,
    defaultMessage: "Please provide your current password.",
    description: "Input error displayed if current password is not entered"
  },
  incorrectCurrentPassword: {
    id: `${PASSWORD_UPDATE_FORM}.incorrect-current-password`,
    defaultMessage: "Current password is incorrect."
  },
  changePassword: {
    id: `${PASSWORD_UPDATE_FORM}.change-password`,
    defaultMessage: "Change password",
    description: "button title for change password form"
  },
  passwordUpdated: {
    id: `${PASSWORD_UPDATE_FORM}.password-updated`,
    defaultMessage: "Your password has been successfully updated."
  },
  unableToUpdatePassword: {
    id: `${PASSWORD_UPDATE_FORM}.unable-to-update`,
    defaultMessage: "Unable to update password. Please try again."
  }
});

export default passwordUpdateFormMessages;
